import React, {useEffect} from "react";
import {connect} from 'react-redux'
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import Loading from "components/Loading";
import {makeStyles} from "@material-ui/core";
import DemandPlanRealizationService from "services/DemandPlanRealizationService";
import DemandValidationMessages from "components/DemandValidationMessages";
import DemandPlanRealizationTable from "./components/DemandPlanRealizationTable";
import Form from "components/Form";
import VS from "constants/ValidationShema";
import Tr from "translations/Translations";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import SaveFormikValues from "../../../../../../../components/SaveFormikValues";


const useStyle = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    icon: theme.components.icon,
    italic: {
        fontStyle: 'italic',
    },
    text: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(4)
    }
}))

function DemandPlanRealizationPanel(
    {
        match,
        demandValidation,
        demandHeader,
        demandPlanRealizations
    }) {

    const classes = useStyle();
    const curDemandValidation = DemandValidation.DEMAND_PLAN_REALIZATION;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;

    useStepperStateCloseValidator('mp_4_demand_plan_realization')

    useEffect(() => {
        DemandPlanRealizationService.getRealizations(demandId);
        return () => {
            DemandPlanRealizationService.clearResources();
        }
    }, [demandId])


    const onSubmit = (values) => {

        DemandPlanRealizationService.saveRealizations(demandId, values).then();

    }

    const validationSchema = VS.arrayOf(VS.lazy(realization => {
        if (realization.canceled)
            return VS.any();

        const shape = {
            realizationValue: VS.numberPositiveOptional().when('realizationGrossValue', {
                is: (realizationGrossValue) => !!realizationGrossValue,
                then: VS.numberPositiveNoZero()
            }),
            realizationGrossValue: VS.numberPositiveOptional().when('realizationValue', {
                is: (realizationValue) => !!realizationValue,
                then: VS.number().min(VS.ref('realizationValue'), Tr('gross_less'))
            })
        }
        return VS.object(shape, [['realizationValue', 'realizationGrossValue']])
    }))


    if (!demandPlanRealizations || !demandHeader) return <Loading/>

    return (<div className={classes.root}>
            <DemandValidationMessages editable={editable} section={section}/>
            <Form
                id='mp_4_demand_plan_realization'
                initialValues={demandPlanRealizations.map(x => ({...x, _touched: false}))}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {(formikProps) => (<>
                    <SaveFormikValues
                        formikProps={formikProps}
                        id='mp_4_demand_plan_realization'
                    />
                    <DemandPlanRealizationTable
                        demandPlanRealizations={demandPlanRealizations}
                        editable={editable}
                        demandId={demandId}
                        formikProps={formikProps}
                        passiveOfferForm={demandHeader.passiveOfferForm}
                        exPost={demandHeader.exPost}
                    />
                </>)}
            </Form>
        </div>
    )
}


export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    demandValidation: state.resources.demandValidation,
    demandPlanRealizations: state.resources[DemandPlanRealizationService.DEMAND_PLAN_REALIZATIONS_RESOURCE_ID]
}), {})(withRouter(DemandPlanRealizationPanel));